import Vue from 'vue';
import VueI18n from 'vue-i18n';
import fr from './langs/fr';
import dateTimeFormats from './dateTimeFormats';
import numberFormats from './numberFormats';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'fr',
  numberFormats,
  dateTimeFormats,
  messages: {
    fr,
  },
});

export default i18n;
